<!doctype html>
<section>
    <div class="row py-4 px-5" style="margin: 0;">
        <div class="col-12 py-1  px-0">
            <h3>CONTACTO</h3>
        </div>

        <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 py-3 px-0">
         
            <a href="../../assets/recursos-text/Curriculum patricia valdebenito 05_03_2020.pdf" download target="_blank">
              <div >
                <i class="fas fa-file-download" style="margin-right: 10px;"></i>
                <span>Descarga Curriculum</span>
              </div>
            </a>
        </div>
        <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 py-3 px-0">
            <div>
                <ul>                                   
                    <li>
                        <a href="https://www.linkedin.com/in/patricia-valdebenito" target="_blank"><i class="fab fa-linkedin" style="margin-right: 10px;"></i>LinkedIn</a>
                    </li>
                    <li>
                        <a href="https://github.com/Patriciavaldebenito" target="_blank"><i class="fab fa-github" style="margin-right: 10px;"></i>GitHub</a>
                    </li>
                   <!-- <li>
                        <a href=""><i class="far fa-envelope" style="margin-right: 10px;"></i>Copia Correo</a>
                       
                    </li>
                    
                -->
         
                    <li>
                        <a routerLink="/home"><i class="fas fa-home" style="margin-right: 10px;"></i>volver a Home</a>
                    </li>


                    <li>
                        <a routerLink="/project"><i class="fas fa-shopping-bag" style="margin-right: 10px;"></i>volver a Proyectos</a>
                    </li>


                    <li>
                        <a href="https://app.talento.laboratoria.la/profile/1uGzPjh9P4UAIpyepsJjDe2kAZU2" target="_blank">Aplicacion Job Laboratoria</a>
                    </li>
                    <li></li>
                </ul>
            </div>
        </div>
    </div>
</section>